import { render, staticRenderFns } from "./CreateSimpleProduct.vue?vue&type=template&id=af6b2cc8&scoped=true&"
import script from "./CreateSimpleProduct.vue?vue&type=script&lang=js&"
export * from "./CreateSimpleProduct.vue?vue&type=script&lang=js&"
import style0 from "./CreateSimpleProduct.vue?vue&type=style&index=0&id=af6b2cc8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af6b2cc8",
  null
  
)

export default component.exports